module.exports = __webpack_public_path__ + "img/ico-power.1f7741d0.svg";